import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";

interface PopupAlertProps {
	open: boolean;
	message: string;
	onClose: () => void; // REQUIRED
}

const PopupAlert: React.FC<PopupAlertProps> = ({ open, message, onClose }) => {
	return (
		<Dialog open={open} onClose={onClose}>
			<DialogTitle style={{ fontWeight: "bold", color: "#d32f2f" }}>Alert</DialogTitle>

			<DialogContent>
				<p style={{ fontSize: "16px", margin: 0 }}>{message}</p>
			</DialogContent>

			<DialogActions>
				<Button variant="contained" color="primary" sx={{ backgroundColor: "#d32f2f" }} onClick={onClose}>
					OK
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default PopupAlert;
